export { CollapseDirective } from './collapse.directive';
export { CollapseModule } from './collapse.module';



// WEBPACK FOOTER //
// ./src/app/typescripts/free/collapse/index.ts